module.exports = {
      id: "8a486b654b6dce11df04ddd4cb163c89sewerage-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#8a486b654b6dce11df04ddd4cb163c89sewerage-none.svg",
      toString: function () {
        return this.url;
      }
    }